import React from 'react';
import {
  ModalOverlay,
  ModalContent,
  ModalTitle,
  ItemTypesGrid,
  ItemTypeButton,
  ItemTypeIcon,
  ItemTypeTitle,
  ItemTypeDescription,
  ModalFooter
} from './style';
import { Package, ShoppingCart, Wrench, Briefcase } from 'lucide-react';
import { Button } from '../../style';

interface AddItemModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelectType: (type: 'MATERIAL' | 'PRODUCT' | 'RESOURCE' | 'SERVICE') => void;
}

const AddItemModal: React.FC<AddItemModalProps> = ({ isOpen, onClose, onSelectType }) => {
  const itemTypes = [
    {
      value: 'MATERIAL',
      label: 'Matéria Prima',
      icon: Package,
      description: 'Materiais base para produção'
    },
    {
      value: 'PRODUCT',
      label: 'Produto Final',
      icon: ShoppingCart,
      description: 'Produto acabado'
    },
    {
      value: 'RESOURCE',
      label: 'Insumos',
      icon: Wrench,
      description: 'Recursos e ferramentas'
    },
    {
      value: 'SERVICE',
      label: 'Serviços',
      icon: Briefcase,
      description: 'Serviços especializados'
    }
  ] as const;

  const handleSelectType = (type: 'MATERIAL' | 'PRODUCT' | 'RESOURCE' | 'SERVICE') => {
    onSelectType(type);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <ModalOverlay>
      <ModalContent>
        <ModalTitle>Selecione o tipo de produto</ModalTitle>
        <ItemTypesGrid>
          {itemTypes.map((type) => {
            const IconComponent = type.icon;
            return (
              <ItemTypeButton key={type.value} onClick={() => handleSelectType(type.value)}>
                <ItemTypeIcon as={IconComponent} size={32} />
                <ItemTypeTitle>{type.label}</ItemTypeTitle>
                <ItemTypeDescription>{type.description}</ItemTypeDescription>
              </ItemTypeButton>
            );
          })}
        </ItemTypesGrid>
        <ModalFooter>
          <Button variant="danger-outline" onClick={onClose}>
            Cancelar
          </Button>
        </ModalFooter>
      </ModalContent>
    </ModalOverlay>
  );
};
export default AddItemModal;
